import AbweichenderZahlungsempfaenger from "./abweichenderZahlungsempfaenger"
import Ueberweisung from "./ueberweisung"
import Zahlungsbedingung from "./zahlungsbedingung"

const initialesSkonto = new Zahlungsbedingung()
initialesSkonto.typ = "SKONTO"

export class Zahlungsdaten {
    // BT-81
    zahlungsmittelCode = "58"
    // BT-83
    verwendungszweck = ""
    // BT-20
    zahlungsbedingungen = [initialesSkonto]
    // BT-89
    sepaMandatsreferenz = ""
    // BT-90
    sepaGlaeubigerID = ""
    // BT-91
    sepaIbanKonto = ""
    // BT-87
    kreditkartennummer = ""
    // BT-88
    karteninhaber = ""
    abweichenderZahlungsempfaenger = new AbweichenderZahlungsempfaenger()
    ueberweisung: Ueberweisung[] = [new Ueberweisung()]

    removeUeberweisung(index: number) {
        this.ueberweisung.splice(index, 1)
    }

    toJSON() {
        return {
            zahlungsmittelCode: this.zahlungsmittelCode,
            // BT-82
            // zahlungsmittelText: getPaymentMeansOptions().find((p) => p.value === this.zahlungsmittelCode)?.label || undefined,
            verwendungszweck: this.verwendungszweck,
            zahlungsbedingungen: this.zahlungsbedingungen.filter((zb) => zb.zahlungszeile.trim().length > 0).length > 0 ? this.zahlungsbedingungen : undefined,
            sepaMandatsreferenz: this.sepaMandatsreferenz,
            sepaGlaeubigerID: this.sepaGlaeubigerID,
            sepaIbanKonto: this.sepaIbanKonto,
            kreditkartennummer: this.kreditkartennummer,
            karteninhaber: this.karteninhaber,
            abweichenderZahlungsempfaenger: this.abweichenderZahlungsempfaenger,
            ueberweisung: this.ueberweisung.filter((u) => u.notEmpty),
        }
    }
}
